import type { FontLoaderService } from './font-loader-service.js';

const KALAM_FONT_FAMILY = 'Kalam';
const KALAM_FONT_QUERY = '600 21px "Kalam"';

export function isCanvasHandwritingFontReady() {
  if (typeof document === 'undefined' || !document.fonts) return true;

  let ready = false;
  document.fonts.forEach(fontFace => {
    const family = fontFace.family.replaceAll('"', '');
    if (
      family === KALAM_FONT_FAMILY &&
      fontFace.weight === '600' &&
      fontFace.status === 'loaded'
    ) {
      ready = true;
    }
  });
  return ready;
}

export async function waitForCanvasHandwritingFont(
  fontLoader?: FontLoaderService | null
) {
  if (typeof document === 'undefined' || !document.fonts) return;
  await fontLoader?.ready;
  await document.fonts.load(KALAM_FONT_QUERY);
}
